import { Calendar, getCalendarEntry } from 'owa-calendar-cache';

import type { CalendarGroup } from 'owa-graph-schema';

export function sortByGroups(source: Calendar[], groups: CalendarGroup[]): Calendar[] {
    let result = [];
    groups.forEach(group => {
        result.push(
            ...source.filter(item => {
                let calendarEntry = getCalendarEntry(item);
                return calendarEntry && group.serverGroupId == calendarEntry.ParentGroupId;
            })
        );
    });

    return result;
}
